<h1 class="title-header mb-27">{{ 'events.submissions.title' | translate | titlecase }}</h1>

<div class="tabs-wrapper">
  <wlx-tabs [collapseSubTabs]="true">
    <wlx-tab [title]="'events.submissions.submission-list.title' | translate | titlecase">
      <ng-template wlLazyTabContent>
        <wl-submission-list (reviewSubmission)="reviewSubmission($event)"></wl-submission-list>
        <wl-submission-review-modal #reviewModal></wl-submission-review-modal>
      </ng-template>
    </wlx-tab>

    <wlx-tab [title]="'events.submissions.submission-form-settings.title' | translate | titlecase">
      <ng-template wlLazyTabContent>
        <wl-submission-form-settings></wl-submission-form-settings>
      </ng-template>
    </wlx-tab>
  </wlx-tabs>
</div>
